module.exports = {
   authorisations: require('./authorisations'),
   actions: require('./actions'),
   permissions: require('./permissions')
};
